import angular from 'angular';
import { default as userService } from 'app/services/membership/ss.user.service';
import { default as orgDataService } from 'app/services/data/org.data.service';
import { default as authorizationService } from 'app/services/membership/ss.authorization.service';
import controller from './system-notifications.directive.controller';
import directive from './system-notifications.directive';

export default angular.module('app.components.global.systemNotifications', [
  userService,
  orgDataService,
  authorizationService
])
  .directive('systemNotifications', directive)
  .controller('SystemNotificationsDirectiveController', controller)
  .name;

console.log('app.components.global.systemNotifications created');
